module.exports = __webpack_public_path__ + "static/PlanningScreen-b2e6dcb9ebc85e8ceaa1589021d78464.svg";